import {PureComponent} from 'react'
import PropTypes from 'prop-types'

import IllustratedDiv from '../IllustratedDiv/IllustratedDiv.jsx'
import LinkAs from '../LinkAs/LinkAs.jsx'

import {generate} from '../../routes.js'

export default class OurJobs extends PureComponent {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        brief: PropTypes.string.isRequired,
        img: PropTypes.string.isRequired,
        imgAlt: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      })
    ).isRequired
  }

  static defaultProps = {
    items: []
  }

  render() {
    if (!this.props.items.length) {
      return null
    }

    return (
      <section className="container py-5">
        {this.props.items.map((item, index) => {
          const searchLink = generate({
            name: 'search',
            search: {keywords: item.keywords || []}
          })

          return (
            <IllustratedDiv key={index} imgSrc={item.img} imgAlt={item.imgAlt}>
              <h2 className="mb-3">{item.title}</h2>
              <div dangerouslySetInnerHTML={{__html: item.brief}}/>
              <LinkAs
                do={generate({name: 'drop-need'})}
                freelance={searchLink}
                notConnected={generate({name: 'drop-need'})}
                className="mx-auto btn btn-lg btn-primary"
              >
                Trouver un consultant
              </LinkAs>
            </IllustratedDiv>
          )
        })}
      </section>
    )
  }
}
